import { PaginationProps } from "antd"

export const paginationConfig: PaginationProps = {
  hideOnSinglePage: true,
  showSizeChanger: false,
  showTotal: (total, [from, to]) => `${from}-${to} of ${total}`,
  size: "small",
}
